const initialState = () => ({
  corporation: {},
  partnerSettings: {},
  current: {},
  partnerList: [],
  loading: true,
  showActionModal: false,
  actionModalView: '',
  adminFilter: {
    corpId: 0,
    corpName: '',
    partner: {
      psm: 0,
      psmName: 'All PSM',
      type: [],
      engagementLevel: '',
      status: '',
    },
  },
  showRightSidebar: false,
  showSearch: false,
  imageForm: new FormData(),
  watchlistData: [],
  showWatchlist: false,
  appOnly: false,
  systemNotification: null,
});

export default initialState;
